import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import LayersRoundedIcon from "@mui/icons-material/LayersRounded";

import "./FloorPlanPdf.css";
import { useApiQuery, resolveFileUrl } from "../api/client";

const openPdf = (url) => {
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};

const FloorPlanPdf = () => {
  const { ref, inView } = useInView({ threshold: 0.15, triggerOnce: true });
  const { data: floorplanDoc } = useApiQuery("/documents/floorplan");
  const floorPlanUrl = floorplanDoc?.fileUrl ? resolveFileUrl(floorplanDoc.fileUrl) : "";
  const btnLabel = floorplanDoc?.mimeType?.startsWith("image/") ? "View Floor Plan" : "View PDF";

  return (
    <section className="fpp" id="floorplan" ref={ref}>
      <motion.div
        className="fpp__banner"
        initial={{ opacity: 0, y: 14 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.7 }}
      >
        <div className="fpp__bannerInner">
          <div className="fpp__badge">
            <LayersRoundedIcon />
            <span>FLOOR PLAN</span>
          </div>

          {/* ✅ Title + Button (same row) */}
          <div className="fpp__row">
            <div className="fpp__left">
              <h2 className="fpp__title">HB Height Floor Plan</h2>
              {/* <p className="fpp__sub">
                Open the official floor plan PDF in full view (zoom, share, save).
              </p> */}
            </div>

            <button
              type="button"
              className="fpp__btn"
              onClick={() => openPdf(floorPlanUrl)}
              disabled={!floorPlanUrl}
            >
              <VisibilityRoundedIcon />
              {btnLabel}
            </button>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default FloorPlanPdf;
